import { useDispatch } from "react-redux";
import { ContentGroupSettingsButton } from "./";
import { CONTENT_GROUP_SETTINGS } from "../../constants";

const ContentGroupSettings = ({
    workspace_id,
    content_group_id,
    stage_id,
    can_destroy,
    can_clone,
    className = '',
}) => {
    const dispatch = useDispatch();

    const handleSettingsClick = (e) => {
        e.stopPropagation();
        e.preventDefault();

        const boundary = e.currentTarget.getBoundingClientRect();

        dispatch({ type: CONTENT_GROUP_SETTINGS.OPEN_CONTENT_GROUP_SETTINGS, payload: { boundary, content_group_id, workspace_id, stage_id, can_destroy, can_clone } });
    }

    return (
        <ContentGroupSettingsButton onClick={handleSettingsClick} className={className}/>
    );
};


const ContentGroupSettingsNoRedux = ({
    onClick,
    className = ''
}) => {
    return (
         <ContentGroupSettingsButton onClick={onClick} className={className}/>
    );
};


export { ContentGroupSettings, ContentGroupSettingsNoRedux };